import React from 'react';

const FormInput = (props) => {
  console.log(props);
  return (
    <div
      className="mt-2 p-4 pt-2"
      style={{ display: 'flex', flexDirection: 'column' }}
    >
      <div>
        <span
          style={{
            fontFamily: 'Inter',
            fontSize: '12px',
            fontWeight: 500,
          }}
        >
          {props.title}
        </span>
        {props.optional && (
          <span
            style={{
              fontSize: '10px',
              color: '#2E2B44',
              backgroundColor: '#F4F0FF',
              padding: '1px',
              borderRadius: '4px',
            }}
          >
            optional
          </span>
        )}
      </div>
      <input
        type="text"
        style={{
          border: '1px solid #A5A6BB',
          borderRadius: '12px',
          padding: '0px 16px',
          height: '48px',
        }}
        placeholder={props.placeholder}
        value={props.value}
        onChange={(e) =>
          props.onChange((d) => {
            return { ...d, [props.name]: e.target.value };
          })
        }
      />
      {props.error && (
        <span
          className="pt-1"
          style={{
            fontFamily: 'Inter',
            fontSize: '12px',
            fontWeight: 500,
            color: '#767787',
          }}
        >
          {props.error}
        </span>
      )}
    </div>
  );
};

export default FormInput;
